import React from "react";

import { CounterSkeleton, LawsuitUpdateCounterSkeletonWrapper } from "./styles";

const LawsuitUpdateCounterSkeleton = () => (
  <LawsuitUpdateCounterSkeletonWrapper>
    <CounterSkeleton />
    <CounterSkeleton />
  </LawsuitUpdateCounterSkeletonWrapper>
);

export default LawsuitUpdateCounterSkeleton;
